import { FCC, LocaleProvider } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { useFrontendConfig } from "./config/useFrontendConfig";
import i18n from "./i18n";
import { ProductTranslationsProvider } from "./i18n/ProductTranslationsProvider";

export const JarvisLocaleProvider: FCC = ({ children }) => {
	const queryClient = useQueryClient();
	const { languageSettings } = useFrontendConfig();
	const [initialized, setInitialized] = useState(false);

	const calculatedInitialLocale = useMemo(() => {
		const initialLocale = Intl.DateTimeFormat().resolvedOptions().locale;
		const initialCode = initialLocale.split("-")[0];
		if (languageSettings.availableLanguages.includes(initialCode)) {
			return initialCode;
		} else {
			return languageSettings.fallback;
		}
	}, [languageSettings.availableLanguages, languageSettings.fallback]);

	useEffect(() => {
		axios.defaults.headers["Content-Language"] = calculatedInitialLocale;
		setInitialized(true);
	}, [calculatedInitialLocale]);

	return (
		<I18nextProvider i18n={i18n}>
			<ProductTranslationsProvider />
			<LocaleProvider
				initialLanguage={calculatedInitialLocale}
				onChange={(language) => {
					if (i18n.language !== language) {
						void i18n.changeLanguage(language);
					}
					document.documentElement.lang = language;
					axios.defaults.headers["Content-Language"] = language;
					void queryClient.invalidateQueries({
						predicate: (query) => !query.queryKey.includes("config") && !query.queryKey.includes("config.json"),
					});
				}}
			>
				{initialized && children}
			</LocaleProvider>
		</I18nextProvider>
	);
};
